import "./zod-config.ts";
import "./styles.css";

import { getLocale } from "@estate-platform/i18n/runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { createDataLayer, DataLayerProvider } from "./data/data-layer.tsx";
import { parseEnvironment } from "./environment.ts";
import { rememberDeviceLanguage } from "./language/device-language.ts";
import { release } from "./release.ts";
import { createAppRouter } from "./router.tsx";
import { applyStoredTheme } from "./shell/theme.ts";

const container = document.querySelector("#root");

if (container === null) {
  throw new Error("Missing #root element");
}

applyStoredTheme();
rememberDeviceLanguage();
document.documentElement.lang = getLocale();

const data = createDataLayer(parseEnvironment(import.meta.env), release);
const router = createAppRouter(data);

createRoot(container).render(
  <StrictMode>
    <DataLayerProvider value={data}>
      <QueryClientProvider client={data.cache.queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </DataLayerProvider>
  </StrictMode>,
);
